export default {"src":"/_next/static/media/icon-video-search.a1a3bb53.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};